export default __webpack_public_path__ + "static/articles-hepatofelin-toksini-25852316512861922a8cb0c2c4a64769.jpg";